import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider.js";

/**
 * Exige sesión válida. Hasta `bootstrapped`, muestra estado de carga.
 */
export function ProtectedLayout(): JSX.Element {
  const { user, bootstrapped, status } = useAuth();
  const location = useLocation();

  if (!bootstrapped || status === "loading") {
    return (
      <div className="loading-screen" role="status">
        <p>Comprobando sesión…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
